import NoticesActions from './NoticesActions';
import TenancyActions from './TenancyActions';
import PropertyActions from './PropertyActions';
import GeneralActions from './GeneralActions';

class DataActions {
  constructor(root) {
    this.root = root;

    this.tenancy = new TenancyActions(this.root);
    this.property = new PropertyActions(this.root);
    this.general = new GeneralActions(this.root);
    this.notices = new NoticesActions(this.root);
  }
}

export default DataActions;
